/**
 * iter76c — Marketing & Ops parent tab. Consolidates all outreach and
 * external-integration settings into one top-level nav item per
 * operator request "figure out what else can be consolidated to make
 * admin look less messy".
 *
 * Sub-tabs:
 *   • Blasts & Segments   → existing MarketingTab (segments, low-stock, margins)
 *   • Newsletter          → subscriber management
 *   • Abandoned Carts     → recovery pipeline
 *   • SEO Blog Gen        → BabyloveTab (AI category-blog generator)
 *   • Meta Pixel          → Facebook Pixel + CAPI settings
 *   • Google Local Feeds  → merchant feed configuration
 *   • Live Chat (Tidio)   → Tidio chat widget settings
 */
import { useState } from "react";
import { Send, Users, ShoppingCart, PenLine, Zap, Package, MessageCircle, Sparkles, Target } from "lucide-react";
import MarketingTab from "./MarketingTab";
import NewsletterSubscribersTab from "./NewsletterTab";
import AiNewsletterTab from "./AiNewsletterTab";
import AbandonedCartsTab from "./AbandonedCartsTab";
import BabyloveTab from "./BabyloveTab";
import MetaPixelSettingsTab from "./MetaPixelSettingsTab";
import GoogleLocalFeedTab from "./GoogleLocalFeedTab";
import TidioSettingsTab from "./TidioSettingsTab";
import AdsTab from "./AdsTab";

const SUBS = [
  { k: "blasts", l: "Blasts & Segments", Icon: Send },
  { k: "ai-newsletter", l: "AI Newsletter", Icon: Sparkles },
  { k: "newsletter", l: "Subscribers", Icon: Users },
  { k: "abandoned", l: "Abandoned Carts", Icon: ShoppingCart },
  { k: "seo", l: "SEO Auto-Publish", Icon: PenLine },
  { k: "google-ads", l: "Google Ads", Icon: Target },
  { k: "meta-pixel", l: "Meta Pixel", Icon: Zap },
  { k: "google-local", l: "Google Local Feeds", Icon: Package },
  { k: "tidio", l: "Live Chat (Tidio)", Icon: MessageCircle },
];

export default function MarketingParentTab({ pw }) {
  const [sub, setSub] = useState("blasts");
  return (
    <div data-testid="marketing-parent-tab">
      <div className="flex gap-1.5 flex-wrap mb-5 border-b border-[#222] pb-2">
        {SUBS.map(({ k, l, Icon }) => (
          <button
            key={k}
            onClick={() => setSub(k)}
            data-testid={`marketing-sub-${k}`}
            className={`px-3 py-1.5 border font-mono text-[10px] tracking-widest uppercase inline-flex items-center gap-1.5 ${
              sub === k
                ? "bg-[var(--tc-red)] border-[var(--tc-red)] text-white"
                : "border-[#222] text-zinc-400 hover:text-white"
            }`}
          >
            <Icon size={11} /> {l}
          </button>
        ))}
      </div>
      {sub === "blasts" && <MarketingTab pw={pw} />}
      {sub === "ai-newsletter" && <AiNewsletterTab pw={pw} />}
      {sub === "newsletter" && <NewsletterSubscribersTab pw={pw} />}
      {sub === "abandoned" && <AbandonedCartsTab pw={pw} />}
      {sub === "seo" && <BabyloveTab pw={pw} />}
      {sub === "google-ads" && <AdsTab pw={pw} />}
      {sub === "meta-pixel" && <MetaPixelSettingsTab pw={pw} />}
      {sub === "google-local" && <GoogleLocalFeedTab pw={pw} />}
      {sub === "tidio" && <TidioSettingsTab pw={pw} />}
    </div>
  );
}
